import { render, staticRenderFns } from "./ListV3.vue?vue&type=template&id=bf4a31e4"
import script from "./ListV3.vue?vue&type=script&lang=js"
export * from "./ListV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports